import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">
          <svg className="footer-star-icon" viewBox="0 0 24 24" fill="none" stroke="white">
            <path d="M8 2h8v3h-2v1h2v2h-2v3h-2v3h-2v-3H8v-3H6V6h2V5H6V2h2zm2 3v1h4V5h-4zm0 2v3h4V7h-4z" fill="white" stroke="none"/>
            <rect x="7" y="14" width="10" height="8" rx="1" stroke="white" strokeWidth="1.5" fill="none"/>
            <line x1="12" y1="14" x2="12" y2="22" stroke="white" strokeWidth="1.5"/>
          </svg>
          <h2>Sanro</h2>
        </div>

        <div className="footer-divider"></div>

        <nav className="footer-nav">
          <a href="#home">Home</a>
          <a href="#about">Sobre nosotros</a>
          <a href="#shop">Tienda</a>
        </nav>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <p>© 2026, All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
